import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/analytics";

export const impressionToggleSwitch = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: string,
    position: string,
    context: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TOGGLE_WIDGET,
        label: cartId,
        value: position,
        context: context,
    });
};

export const clickToggleOn = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartId: string,
    position: string,
    context: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_TOGGLE_ON,
        label: cartId,
        value: position,
        context: context,
    });
};

export const clickToggleOff = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartId: string,
    position: string,
    context: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_TOGGLE_OFF,
        label: cartId,
        value: position,
        context: context,
    });
};

export const impressionContextualBanner = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: string,
    context: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CONTEXTUAL_BANNER,
        label: cartId,
        context: context,
    });
};

export const clickContextualBannerDismiss = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartId: string,
    context: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CONTEXTUAL_BANNER_DISMISS,
        label: cartId,
        context: context,
    });
};
